import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';

import { ThreadsTableViewModel } from 'four-nets/forum/threads-table/threads-table-view';
import { UserStore } from 'four-nets/user/user';
import ErrorPage from 'four-nets/errors/error-page';

import { CategoryStore } from '../forum';
import SubscribedTopicsView, { CategoriesTableViewModel } from './subscribed-topics-view';

class SubscribedTopicsLoader extends React.Component {
    static contextTypes = {
        app: PropTypes.object,
        categoryStore: PropTypes.instanceOf(CategoryStore),
        userStore: PropTypes.instanceOf(UserStore),
    };

    transform = data => {
        const { categoryStore } = this.context;
        const { threadStore } = categoryStore;

        const threadsTableViewModel = new ThreadsTableViewModel();
        const categoriesTableViewModel = new CategoriesTableViewModel();

        threadsTableViewModel.setThreads(threadStore.processPagedJSON({ json: data.threadsTableViewModel.threads }));
        categoriesTableViewModel.setCategories(
            categoryStore.processPlainJSONArray({ json: data.categoriesTableViewModel.categories })
        );

        return {
            threadsTableViewModel,
            categoriesTableViewModel,
        };
    };

    fetch = (setData, { page }) => {
        const { categoryStore } = this.context;
        const { threadStore } = categoryStore;

        return Promise.all([
            threadStore.loadSubscribedThreads({ page }),
            categoryStore.loadSubscribedCategories(),
        ]).then(([threads, categories]) => {
            const threadsTableViewModel = new ThreadsTableViewModel();
            const categoriesTableViewModel = new CategoriesTableViewModel();

            threadsTableViewModel.setThreads(threads);
            categoriesTableViewModel.setCategories(categories.results);

            setData({
                threadsTableViewModel,
                categoriesTableViewModel,
            });
        });
    };

    renderFetch = ({ loading, data, error }) => (
        <LoadingProgress loading={loading}>
            <ErrorPage error={error}>
                <SubscribedTopicsView
                    threadsTableViewModel={data?.threadsTableViewModel}
                    categoriesTableViewModel={data?.categoriesTableViewModel}
                />
            </ErrorPage>
        </LoadingProgress>
    );

    render() {
        const { page = 1 } = this.props.search;

        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                page={page}
                me={this.context.userStore.me}
            />
        );
    }
}

export default observer(SubscribedTopicsLoader);
